"use strict";
export var UniversalRouterVersion = /* @__PURE__ */ ((UniversalRouterVersion2) => {
  UniversalRouterVersion2["_1_2"] = "1.2";
  UniversalRouterVersion2["_2_0"] = "2.0";
  return UniversalRouterVersion2;
})(UniversalRouterVersion || {});
